import classNames from "classnames";
import { ProfileAvatarConnected } from "PFApp/components/profile_avatar_connected";
import Tooltip from "PFComponents/tooltip/tooltip";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { ApiRoute } from "PFCore/utilities/routes";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./progress_bar.less";

const Step = ({ data, currentLevel, role, engagement }) => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    if (data.key === "filled" && data.requester_id) {
      $.ajax({ url: ApiRoute(`/api/profiles/${data.requester_id}`), api_version: 2 }).then((response) =>
        setProfile(response)
      );
    }
  }, []);

  const { t } = useTranslation("workflow", { keyPrefix: "parts.engagements" });
  const { formatDate } = useDateFormatter();

  const draftSuffix = engagement.state === "draft" ? t("progressBar.draftSuffix") : "";
  const startDate = `${formatDate(engagement.created_at)} ${draftSuffix}`;
  const startTooltipContent = t("progressBar.engagementCreatedAtDate", { date: startDate });

  const postUntil = role ? role.post_until : engagement.post_until;
  const endDate = formatDate(postUntil);
  const endTooltipContent = t("progressBar.toBeCompletedByDate", { date: endDate });
  const isCurrentStep = data.level === currentLevel;

  const left = `${data.level * 25}%`;
  let transform = null;
  if (data.level === 0) {
    transform = "translate(0px, -4px)";
  } else if (data.level === 4) {
    transform = "translate(-100%, -2px)";
  }

  if (data.level === 0) {
    return (
      <Tooltip content={startTooltipContent} placement="top-end" theme="pf-info">
        <div className={css.start}>{startDate}</div>
      </Tooltip>
    );
  } else if (data.level === 4 && postUntil && currentLevel !== 4) {
    return (
      <Tooltip content={endTooltipContent} placement="top-start" theme="pf-info">
        <div className={css.end}>{endDate}</div>
      </Tooltip>
    );
  } else {
    return (
      <div className={classNames(css.step, { [css.current]: isCurrentStep })} style={{ left, transform }}>
        <div>
          {profile && <ProfileAvatarConnected profile={profile} size={20} smartLink />}
          <span
            className={classNames(css.label, {
              [css[data.key]]: isCurrentStep,
              [css.disabled]: data.level > currentLevel
            })}
          >
            {data.title}
          </span>
        </div>
        {data.created_at && <small>{formatDate(data.created_at)}</small>}
      </div>
    );
  }
};

Step.propTypes = {
  data: PropTypes.shape({
    level: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    requester_id: PropTypes.number,
    created_at: PropTypes.string
  }),
  engagement: PropTypes.shape({
    state: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    post_until: PropTypes.string
  }).isRequired,
  role: PropTypes.shape({
    state: PropTypes.string.isRequired,
    post_until: PropTypes.string
  }),
  currentLevel: PropTypes.number.isRequired
};

export default Step;
